import { Voices, Personas } from 'aicoach/config';

export const DefaultValues = {
	"status": "active",
	"persona_id": 1,
	"public": 0
};

export const VoiceChoices = Object.entries( Voices ).map( ([ id, v ]) => ({ id, name: v.name }) );
export const PersonaChoices = Object.entries( Personas ).map(([ id, v ]) => ({ id, name: v.name }) );
